import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { connect } from "react-redux";
import { Dispatch } from 'redux';

import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { CardController } from 'src/app/shared/card.controller';
import { ProductServiceTypeDataService } from '../../../product-service-types/parts/product-service-type-editor.data';
import { ContractsServiceView } from './contract-service.view';
import { ContractServiceTypeListDataService } from 'src/app/products/contract/form/contract-service-type-list.data';
import { actionCreators } from "src/store/products/product-form-nav-actions";

interface PropsFromState {
	services: ContractServiceTypeItem[];
	categoryId: number;
}

interface PropsFromDispatch {
	servicesLoaded: (contractItem: ContractItem, markets: ContractServiceTypeItem[]) => any;
}

interface Props extends ComponentViewProps<ContractItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
	product: ProductItem | TourItineraryItem;
}

@observer
class ContractsServiceController extends React.Component<Props & PropsFromDispatch & PropsFromState, {}> {
	@observable
	protected dataService: ContractServiceTypeListDataService;

	@observable
	protected serviceDataService: ProductServiceTypeDataService;

	@resolve
	protected dialogService: DialogService;

	@resolve
	protected toast: ToastNotifications;

	componentDidMount(): void {
		this.dataService = ContractServiceTypeListDataService.make(this.props.contextService);
		this.serviceDataService = ProductServiceTypeDataService.make(this.props.contextService);

		this.loadData();
		this.loadServiceData();
	}

	private loadData(): void {
		if (this.props.model.id && (this.props.services == null)) {
			this.props.setBusy(true);
			this.dataService.addFilter('contractId', 'eq', this.props.model.id);
			this.dataService.addSorting('id', 'asc', true);
			this.dataService.pageSize = 25;
			this.dataService.load(query => query)
				.then((items) => {
					this.props.servicesLoaded(this.props.model, items.slice());
					this.props.setBusy(false);
				})
				.catch((error) => {
					this.props.setBusy(false);
					this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
				});
		} else {
			this.dataService.items = this.props.services;
		}
	}

	private loadServiceData(): void {
		const { setBusy, product, categoryId } = this.props;

		setBusy(true);

		this.serviceDataService.addFilter('categoryId', 'eq', categoryId);
		this.serviceDataService.addFilter('isDeleted', 'eq', false);
		this.serviceDataService.addSorting('id', 'asc', true);
		this.serviceDataService.load(query => query)
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				setBusy(false)
			});
	}

	createNew = (): Promise<void | ContractServiceTypeItem> => {
		return this.dataService
			.create(() => this.dataService.add(this.props.model.id))
			.then((service) => {
				this.props.servicesLoaded(this.props.model, [service]);
				this.props.setBusy(false);
				return service;
			})
			.catch((error) => {
				this.props.setBusy(false);
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			});
	};

	render(): JSX.Element {
		const { model, mode, setBusy, product } = this.props;
		if (model == null) {
			return null;
		}
		let productType: number;
		if (product) {
			if (product.entity.getType() == Model.Products.Logic.ViewModels.ProductItem) {
				productType = (product as ProductItem).productType;
			} else {
				productType = 9;
			}
		}
		let icon: string;
		switch (productType) {
			case 1:
			case 5:
				icon = "icon-restaurant";
				break;
			case 2:
				icon = "car";
				break;
			case 3:
				icon = "icon-train";
				break;
			case 4:
				icon = "icon-plane";
				break;
			default:
				icon = "file";
				break;
		}
		return (
			<CardController
				icon={icon}
				title="Services"
				mode={mode}
				className="card-borderless">
				{
					this.dataService && model &&
					<ContractsServiceView
						mode={mode}
						model={model}
						setBusy={setBusy}
						dataService={this.dataService}
						createNew={this.createNew}
						serviceDataService={this.serviceDataService}
					/>
				}
			</CardController>
		);
	}
}

const mapStateToProps = (
	state: IApplicationState,
	props: Props
): PropsFromState => {
	const contract = state.otherLoadedEntities.find(e => e.entity == props.model.entity) as ContractItem;
	let categoryId: number;
	if (props.product.entity.getType() == Model.Products.Logic.ViewModels.ProductItem) {
		categoryId = (props.product as ProductItem).categoryId;
	} else {
		//const itinerary = state.otherLoadedEntities.find(e => e.entity == props.product.entity) as TourItineraryItem;
		const product = state.otherLoadedEntities.find(e => e["itineraries"] != null) as ProductItem;
		categoryId = product.entity.categoryId;
	}
	return {
		services: contract.services,
		categoryId: categoryId,
	};
};

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
	servicesLoaded: (
		contract: ContractItem,
		services: ContractServiceTypeItem[],
	) => dispatch(actionCreators.productFormRelationshipLoaded(contract, services, "services")),
});

const connected = connect(mapStateToProps, mapDispatchToProps)(ContractsServiceController);
export { connected as ContractsServiceController };



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-service.controller.tsx